module.exports = __webpack_public_path__ + "static/media/videoLibraryLeftArrow.be9109a4.svg";